module.exports = __webpack_public_path__ + "img/alquileres.a57b98f1.jpg";